import { render, staticRenderFns } from "./CommonBanner.vue?vue&type=template&id=719abbc2"
import script from "./CommonBanner.vue?vue&type=script&lang=js"
export * from "./CommonBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports